const namespace = 'user'

export const getCurrentUser = state => state[namespace].get('current')
export const isTour = state => state[namespace].getIn(['current', 'isTouer'])
export const todoRefreshKeySelector = state => state[namespace].get('todoRefreshKey')
